import * as React from 'react';
import createSvgIcon from './createSvgIcon';
/**
 * @ignore - internal component.
 */

export default createSvgIcon(React.createElement("path", {
  d: "M15.41 16.09l-4.58-4.59 4.58-4.59L14 5.5l-6 6 6 6z"
}), 'KeyboardArrowLeft');


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/core/esm/internal/svg-icons/KeyboardArrowLeft.js
// module id = 717
// module chunks = 0